import React, { useMemo } from "react";
import { useQueryEngagementsListAll } from "../../../../query/engagements/queries/useQueryEngagementsListAll";
import {
  WSEmptyState,
  WSTable,
  WSTableCell,
  WSTableColumn
} from "@wingspanhq/fe-component-library";
import { getEngagementLabelByType } from "../../../Payers/utils/engagement";
import { useHistory } from "react-router-dom";
import { openInNewTab } from "../../../../shared/utils/openInNewTab";
import {
  buildEngagementTypeDetailsURL,
  ENGAGEMENT_TYPES_ROOT_PATH
} from "../../../../modules/EngagementTypes/paths";

export const EngagementsTable: React.FC<{ requirementId: string }> = ({
  requirementId
}) => {
  const history = useHistory();
  const engagementsListAllQuery = useQueryEngagementsListAll({
    filter: {
      isDefault: false
    }
  });

  const tableData = useMemo(() => {
    const engagements = engagementsListAllQuery.data ?? [];
    return engagements
      .filter(e => e.requirementDefinitionIds?.includes(requirementId))
      .map(engagement => ({
        id: engagement.engagementId,
        data: engagement
      }));
  }, [engagementsListAllQuery.data, requirementId]);

  const columns: Array<WSTableColumn> = [
    {
      config: {
        gridTemplateSizeMax: "0.5fr",
        header: {
          text: "Name"
        }
      },
      renderFunction: rowItem => (
        <WSTableCell
          text={rowItem.data.name}
          secondaryText={rowItem.data.description}
        />
      )
    },
    {
      config: {
        header: {
          text: "Type"
        },
        hideOnScreens: ["XS"]
      },
      renderFunction: rowItem => (
        <WSTableCell
          text={getEngagementLabelByType(rowItem.data.type, {
            descriptive: true
          })}
        />
      )
    }
  ];

  return tableData.length > 0 ? (
    <WSTable
      loading={engagementsListAllQuery.isLoading}
      tableData={tableData}
      columns={columns}
      onRowClick={({ data: engagement }) => {
        history.push(buildEngagementTypeDetailsURL(engagement.engagementId));
      }}
      onRowControlClick={({ data: engagement }) => {
        openInNewTab(buildEngagementTypeDetailsURL(engagement.engagementId));
      }}
      onRowMousewheelClick={({ data: engagement }) => {
        openInNewTab(buildEngagementTypeDetailsURL(engagement.engagementId));
      }}
      rowActions={({ data: engagement }) => [
        {
          text: "View",
          onClick: () => {
            history.push(
              buildEngagementTypeDetailsURL(engagement.engagementId)
            );
          }
        }
      ]}
      data-testid="requirementEngagementsTable"
    />
  ) : (
    <WSEmptyState
      py="3XL"
      hasBorder
      orientation="horizontal"
      type="documents"
      title="Requirement is not assigned to an engagement yet"
      description="List of engagements with this requirement will appear here."
      bgColor="gray"
      actions={{
        buttons: [
          {
            label: "Open engagements",
            kind: "Secondary",
            onClick: () => {
              history.push(ENGAGEMENT_TYPES_ROOT_PATH);
            }
          }
        ]
      }}
    />
  );
};
